var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_site_form_editTitle")
        : _vm.$t("label_essweb_site_form_viewTitle"),
      widthClass: "max-1000",
      delBtn: _vm.hasBtn("delete-admin-site-management"),
      backgroundClass: "white",
      editBtn: !_vm.iSEdited && _vm.hasBtn("edit-admin-site-management"),
    },
    on: {
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_site_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "from", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  {
                    staticClass: "white lighten-5",
                    attrs: { align: "center", justify: "start" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.siteData.site_name,
                            label: _vm.$t(
                              "label_essweb_site_form_siteNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.siteData.site_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "3",
                          md: "3",
                          lg: "3",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.siteData.site_abbr,
                            label: _vm.$t(
                              "label_essweb_site_form_siteAbbrLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.siteData.site_abbr = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "3",
                          md: "3",
                          lg: "3",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            maxlength: 100,
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            rules: _vm.$GetRules(
                              ["_Require_Rules", "_Length_Rules"],
                              [null, 100]
                            ),
                            label: _vm.$t(
                              "label_essweb_ClaimReason_form_codeLabel"
                            ),
                          },
                          model: {
                            value: _vm.siteData.site_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.siteData, "site_code", $$v)
                            },
                            expression: "siteData.site_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.siteData.site_description,
                            label: _vm.$t(
                              "label_essweb_site_form_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.siteData.site_description = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-row"),
                _c(
                  "v-row",
                  {
                    staticClass: "white lighten-5",
                    attrs: { align: "center", justify: "start" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            type: "number",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            readonly: !_vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_site_form_longtitudeLabel"
                            ),
                          },
                          model: {
                            value: _vm.siteData.longitude,
                            callback: function ($$v) {
                              _vm.$set(_vm.siteData, "longitude", $$v)
                            },
                            expression: "siteData.longitude",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            type: "number",
                            filled: _vm.iSEdited,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            readonly: !_vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_site_form_latitudeLabel"
                            ),
                          },
                          model: {
                            value: _vm.siteData.latitude,
                            callback: function ($$v) {
                              _vm.$set(_vm.siteData, "latitude", $$v)
                            },
                            expression: "siteData.latitude",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            readonly: !_vm.iSEdited,
                            bindData: _vm.siteData.address_line_1,
                            label: _vm.$t(
                              "label_essweb_site_form_addressLine1Label"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.siteData.address_line_1 = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            showLabel: false,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.siteData.address_line_2,
                            label: _vm.$t(
                              "label_essweb_site_form_addressLine2Label"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.siteData.address_line_2 = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            showLabel: false,
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.siteData.address_line_3,
                            label: _vm.$t(
                              "label_essweb_site_form_addressLine3Label"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.siteData.address_line_3 = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            items: _vm.allCountry,
                            label: "label_essweb_site_form_countryLabel",
                            "item-text": "name",
                            "item-value": "id",
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            placeholder: _vm.$t(
                              "label_essweb_site_form_countryLabel"
                            ),
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                          },
                          model: {
                            value: _vm.siteData.country_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.siteData, "country_uuid", $$v)
                            },
                            expression: "siteData.country_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            items: _vm.allCity,
                            label: "label_essweb_site_form_cityLabel",
                            "item-text": "name",
                            "item-value": "id",
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            placeholder: _vm.$t(
                              "label_essweb_site_form_cityLabel"
                            ),
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            disabled: !_vm.siteData.country_uuid,
                          },
                          model: {
                            value: _vm.siteData.city_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.siteData, "city_uuid", $$v)
                            },
                            expression: "siteData.city_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            items: _vm.siteType,
                            label: "label_essweb_site_form_siteTypeLabel",
                            "item-text": "site_type_name",
                            "item-value": "uuid",
                            "small-chips": "",
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "deletable-chips": "",
                            chips: "",
                            readonly: !_vm.iSEdited,
                            multiple: "",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                            filled: _vm.iSEdited,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " + _vm._s(data.item.site_type_name) + " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.title",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " + _vm._s(data.item.site_type_name) + " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.siteData.site_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.siteData, "site_type_uuid", $$v)
                            },
                            expression: "siteData.site_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            label: _vm.$t(
                              "label_essweb_site_form_effectiveDateLabel"
                            ),
                            filled: _vm.iSEdited,
                            type: "date",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                            max: _vm.siteData.expired_utc_datetime,
                            defaultTime: _vm.siteData.effective_utc_datetime,
                            placeholder: "YYYY/MM/DD",
                          },
                          on: {
                            change: function (time) {
                              _vm.siteData.effective_utc_datetime = time
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            min: _vm.siteData.effective_utc_datetime,
                            defaultTime: _vm.siteData.expired_utc_datetime,
                            label: _vm.$t(
                              "label_essweb_site_form_expiredDateLabel"
                            ),
                            type: "date",
                            placeholder: "YYYY/MM/DD",
                            filled: _vm.iSEdited,
                          },
                          on: {
                            change: function (time) {
                              _vm.siteData.expired_utc_datetime = time
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(_vm.$t("label_essweb_site_form_remarkLabel"))
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            filled: _vm.iSEdited,
                            "single-line": "",
                            readonly: !_vm.iSEdited,
                            counter: "500",
                            dense: "",
                            name: "input-7-4",
                          },
                          model: {
                            value: _vm.siteData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.siteData, "remarks", $$v)
                            },
                            expression: "siteData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: { save: _vm.toSave, cancel: _vm.toBack },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }